import { render, staticRenderFns } from "./subjectRecordCreateModal.vue?vue&type=template&id=f79adb90&"
import script from "./subjectRecordCreateModal.vue?vue&type=script&lang=ts&"
export * from "./subjectRecordCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports